var map = {
	"./add.svg": 5577,
	"./arrow.svg": 4107,
	"./bank-id.svg": 724,
	"./caret-down.svg": 5522,
	"./certificate.svg": 5629,
	"./certificates.svg": 7700,
	"./check-white.svg": 4336,
	"./check.svg": 2400,
	"./check_circle.svg": 475,
	"./chevron.svg": 2537,
	"./cog.svg": 1845,
	"./copy.svg": 9599,
	"./dashboard.svg": 9743,
	"./delete.svg": 2561,
	"./developer.svg": 1238,
	"./dots-vertical.svg": 6039,
	"./download.svg": 8376,
	"./duplicate.svg": 7331,
	"./edit.svg": 8908,
	"./en.svg": 8457,
	"./external-link.svg": 6810,
	"./feedback.svg": 1245,
	"./file.svg": 2714,
	"./hamburger.svg": 3933,
	"./info.svg": 3812,
	"./issue-disturbance.svg": 8390,
	"./issue-downtime.svg": 5441,
	"./issue-planned.svg": 5076,
	"./lock-closed.svg": 4766,
	"./lock-open.svg": 2674,
	"./lock.svg": 8061,
	"./rectangle.svg": 7639,
	"./refresh.svg": 6177,
	"./resolve.svg": 4372,
	"./revoke.svg": 8826,
	"./select-caret-down.svg": 5427,
	"./share.svg": 3841,
	"./support.svg": 4141,
	"./sv.svg": 3983,
	"./thumb-down.svg": 777,
	"./thumb-up.svg": 3910,
	"./times.svg": 7925,
	"./union.svg": 6397,
	"./users.svg": 8280,
	"./view.svg": 1683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9502;